import React from "react";
import { FaArrowLeft, FaHeart, FaTrashAlt, FaShoppingCart, FaShieldAlt } from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import "./style/CartWishlist.css";

/**
 * Returns the GST-inclusive display price for a wishlist item.
 * Customize products use 6-inch as the default display size.
 */
const getDisplayPrice = (item) => {
    if (item.type === "Customize") {
        return Math.round(item.sellingPrice * 6 * 1.18);
    }
    return Math.round(item.sellingPrice * 1.18);
};

const getDisplayMrp = (item) => {
    if (item.type === "Customize") {
        return Math.round(item.mrp * 6 * 1.18);
    }
    return Math.round(item.mrp * 1.18);
};

const WishlistPage = ({ wishlist, onBack, onOpenProduct, onRemoveFromWishlist, onAddToCart }) => {
    return (
        <div
            className="personal-view-page"
            style={{
                backgroundColor: myCustomTheme.colors.header_footer_bg,
                boxShadow: myCustomTheme.shadows.soft,
                borderRadius: "30px"
            }}
        >
            <button
                className="back-btn"
                onClick={onBack}
                style={{
                    backgroundColor: myCustomTheme.colors.button_bg,
                    color: myCustomTheme.colors.button_text
                }}
            >
                <FaArrowLeft /> Back to Products
            </button>

            <h1 className="view-title" style={{ color: myCustomTheme.colors.heading }}>
                My Wishlist ({wishlist.length} Item{wishlist.length !== 1 ? "s" : ""})
            </h1>

            {wishlist.length === 0 ? (
                <div className="empty-state-container">
                    <FaHeart
                        className="empty-state-icon visual-wishlist"
                        style={{ color: myCustomTheme.colors.bg_secondary }}
                    />
                    <p style={{ color: myCustomTheme.colors.menu_text }}>Your wishlist is empty.</p>
                </div>
            ) : (
                <div className="items-list-container">
                    {wishlist.map((item) => {
                        const sp  = getDisplayPrice(item);
                        const mrp = getDisplayMrp(item);
                        return (
                            <div
                                key={item.id}
                                className="item-row-card"
                                onClick={() => onOpenProduct(item)}
                                style={{
                                    backgroundColor: myCustomTheme.colors.bg_primary,
                                    border: `1px solid ${myCustomTheme.colors.high_light}`,
                                    borderRadius: "20px"
                                }}
                            >
                                <img
                                    src={item.images && item.images[0]}
                                    alt=""
                                    className="item-row-thumb"
                                    style={{ borderRadius: "12px", objectFit: "cover" }}
                                />
                                <div className="item-row-info">
                                    <h3 style={{ color: myCustomTheme.colors.heading }}>{item.name}</h3>
                                    <p className="item-row-price" style={{ color: myCustomTheme.colors.heading }}>
                                        ₹{sp}{" "}
                                        {mrp > sp && (
                                            <span className="item-row-mrp" style={{
                                                color: myCustomTheme.colors.menu_text,
                                                textDecoration: "line-through",
                                                fontSize: "12px"
                                            }}>
                                                ₹{mrp}
                                            </span>
                                        )}
                                    </p>
                                    <p style={{
                                        fontSize: "10px", color: "#15803d", fontWeight: "600",
                                        margin: "2px 0 0 0", display: "flex", alignItems: "center", gap: "3px"
                                    }}>
                                        <FaShieldAlt style={{ fontSize: "9px" }} />
                                        18% GST included
                                        {item.type === "Customize" && " · 6\" default"}
                                    </p>
                                </div>
                                <div className="item-row-actions">
                                    <button
                                        className="row-action-btn buy"
                                        onClick={(e) => { e.stopPropagation(); onAddToCart(item, e); }}
                                        style={{
                                            backgroundColor: myCustomTheme.colors.button_bg,
                                            color: myCustomTheme.colors.button_text
                                        }}
                                    >
                                        <FaShoppingCart style={{ marginRight: "6px" }} /> Add to Cart
                                    </button>
                                    <button
                                        className="row-action-btn delete"
                                        onClick={(e) => { e.stopPropagation(); onRemoveFromWishlist(item.id, e); }}
                                        style={{
                                            backgroundColor: myCustomTheme.colors.bg_secondary,
                                            color: "#ef4444"
                                        }}
                                    >
                                        <FaTrashAlt />
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default WishlistPage;